export default __webpack_public_path__ + "static/BundesSans-Web-Medium-54c12b04884627c8a8ec30541cd67fb6.woff";